export default __webpack_public_path__ + "static/media/caliper-strengths.135c2c38.png";